// services/api/errorHandler.ts
import * as Sentry from "@sentry/react";

export const errorMessagesHandling = (
  error: any,
  errorText?: string,
  entityName?: string
) => {
  const status = error?.response?.status;
  const code = error?.code;

  // ✅ Define which status codes to suppress (expected user-flow errors)
  const suppressedStatuses = [400, 401, 403, 404, 409];
  const suppressedCodes = ["ERR_NETWORK"];

  // ✅ Log only if not suppressed
  if (!suppressedStatuses.includes(status) && !suppressedCodes.includes(code)) {
    Sentry.captureException(error);
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  switch (error.code) {
    case "ERR_BAD_REQUEST":
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      switch (error.response.status) {
        case 400:
          console.error(errorText ?? "Bad request");
          break;
        case 401:
          console.error(errorText ?? "Your session has expired");
          break;
        case 403:
          console.error(errorText ?? "Forbidden");
          break;
        case 404:
          console.error(errorText ?? `${entityName ?? "Item"} not found`);
          break;
        case 409:
          console.error(errorText ?? "Conflict");
          break;
        case 413:
          console.error(errorText ?? "Request entity too large");
          break;
        case 415:
          console.error(errorText ?? "Unsupported media type");
          break;
        case 500:
          console.error("Internal server error");
          break;
        case 503:
          console.error("Service unavailable");
          break;
        case 504:
          console.error("Gateway timeout");
          break;
        default:
          console.error("Action failed");
          break;
      }
      break;
    case "ERR_NETWORK":
      console.error("Problem with network, please try again later");
      break;
  }

  throw error;
};
